import{supabaseClient}from'../net/supabase-client.js?v=20260801-token-hash-1';

export async function fetchWallet(userId){
  const{data,error}=await supabaseClient
    .from('wallets')
    .select('user_id,idlecoin,emerald,last_sync_at,migration_completed_at')
    .eq('user_id',userId)
    .single();
  if(error)throw error;
  return data;
}

export async function fetchMarketConfig(keys=[]){
  let query=supabaseClient.from('market_config').select('key,value');
  if(keys.length)query=query.in('key',keys);
  const{data,error}=await query;
  if(error)throw error;
  return Object.fromEntries((data||[]).map(row=>[row.key,row.value]));
}

export async function reportEarnings(events,requestId){
  const{data,error}=await supabaseClient.rpc('report_earnings',{
    p_events:events,
    p_request_id:requestId,
  });
  if(error)throw error;
  return data;
}

export const purchaseShopItem=(slug,qty,requestId)=>rpc('purchase_shop_item',{
  p_slug:slug,p_qty:qty,p_request_id:requestId,
});
export const sellInventoryItems=(items,requestId)=>rpc('sell_inventory_items',{
  p_items:items,p_request_id:requestId,
});
export const sellPlayerPokemon=(pokemonIds,requestId)=>rpc('sell_player_pokemon',{
  p_pokemon_ids:pokemonIds,p_request_id:requestId,
});
export const setPlayerPokemonLocked=(pokemonId,locked,requestId)=>rpc('set_player_pokemon_locked',{
  p_pokemon_id:pokemonId,p_locked:!!locked,p_request_id:requestId,
});
export const spendIdlecoin=(amount,reason,requestId,refId=null)=>rpc('spend_idlecoin',{
  p_amount:amount,p_reason:reason,p_request_id:requestId,p_ref_id:refId,
});

async function rpc(name,params={}){
  const{data,error}=await supabaseClient.rpc(name,params);
  if(error)throw error;
  return data;
}

export const marketSnapshot=()=>rpc('market_snapshot');
export const searchListings=(filters={},sort='recent',page=1)=>rpc('search_listings',{p_filters:filters,p_sort:sort,p_page:page});
export const searchListingsGrouped=(filters={},sort='price_asc',page=1)=>rpc('search_listings_grouped',{p_filters:filters,p_sort:sort,p_page:page});
export const depositItems=(slug,qty,requestId)=>rpc('deposit_items',{p_slug:slug,p_qty:qty,p_request_id:requestId});
export const withdrawItems=(custodyId,requestId)=>rpc('withdraw_items',{p_custody_id:custodyId,p_request_id:requestId});
export const depositPokemon=(pokemon,requestId)=>rpc('deposit_pokemon',{p_pokemon:pokemon,p_request_id:requestId});
export const withdrawPokemon=(custodyId,requestId)=>rpc('withdraw_pokemon',{p_custody_id:custodyId,p_request_id:requestId});
export const createListing=({kind,custodyId,qty,unitPrice,currency,allowOffers,requestId})=>rpc('create_listing',{
  p_kind:kind,p_custody_id:custodyId,p_qty:qty,p_unit_price:unitPrice,
  p_currency:currency,p_allow_offers:allowOffers,p_request_id:requestId,
});
export const cancelListing=(listingId,requestId)=>rpc('cancel_listing',{p_listing_id:listingId,p_request_id:requestId});
export const buyListing=(listingId,qty,requestId)=>rpc('buy_listing',{p_listing_id:listingId,p_qty:qty,p_request_id:requestId});
export const buyBulk=(slug,qty,maxUnitPrice,currency,requestId)=>rpc('buy_bulk',{
  p_slug:slug,p_qty:qty,p_max_unit_price:maxUnitPrice,p_currency:currency,p_request_id:requestId,
});
export const claimDelivery=(deliveryId,requestId)=>rpc('claim_delivery',{p_delivery_id:deliveryId,p_request_id:requestId});
export const marketSocialSnapshot=()=>rpc('market_social_snapshot');
export const makeOffer=({listingId,qty,idlecoin=0,emerald=0,offeredPokemon=[],requestId})=>rpc('make_offer',{
  p_listing_id:listingId,p_qty:qty,p_idlecoin:idlecoin,p_emerald:emerald,
  p_offered_pokemon:offeredPokemon,p_request_id:requestId,
});
export const respondOffer=(offerId,accept,requestId)=>rpc('respond_offer',{p_offer_id:offerId,p_accept:accept,p_request_id:requestId});
export const withdrawOffer=(offerId,requestId)=>rpc('withdraw_offer',{p_offer_id:offerId,p_request_id:requestId});
export const createRequest=({kind,slug=null,species=null,filters={},qty,unitPrice,currency,requestId})=>rpc('create_request',{
  p_kind:kind,p_slug:slug,p_species:species,p_filters:filters,p_qty:qty,
  p_unit_price:unitPrice,p_currency:currency,p_request_id:requestId,
});
export const searchMarketRequests=(filters={},page=1)=>rpc('search_market_requests',{p_filters:filters,p_page:page});
export const fulfillRequest=(marketRequestId,custodyId,qty,requestId)=>rpc('fulfill_request',{
  p_market_request_id:marketRequestId,p_custody_id:custodyId,p_qty:qty,p_request_id:requestId,
});
export const cancelRequest=(marketRequestId,requestId)=>rpc('cancel_request',{p_market_request_id:marketRequestId,p_request_id:requestId});
export const toggleIgnore=(userId,requestId)=>rpc('toggle_ignore',{p_ignored_id:userId,p_request_id:requestId});

export function subscribeToListings(callback){
  const channel=supabaseClient.channel('market:listings')
    .on('postgres_changes',{event:'*',schema:'public',table:'listings'},payload=>callback(payload))
    .subscribe();
  return()=>supabaseClient.removeChannel(channel);
}

export function subscribeToMarketUser(userId,callback){
  const channel=supabaseClient.channel('user:'+userId)
    .on('postgres_changes',{event:'*',schema:'public',table:'offers'},callback)
    .on('postgres_changes',{event:'*',schema:'public',table:'market_requests'},callback)
    .on('postgres_changes',{event:'*',schema:'public',table:'deliveries',filter:'user_id=eq.'+userId},callback)
    .subscribe();
  return()=>supabaseClient.removeChannel(channel);
}
